<script setup>
import HTitle from '~/components/seo/HTitle.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const blockContent = computed(() => props.data?.content || null)
const haveVSpacing = computed(() => blockContent.value.vSpacing)
const shapoIframeUrl = computed(() => {
  const id = blockContent.value?.id?.replace('shapo-widget-', '')
  return `https://app.shapo.io/widgets/${id}`
})
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'mb-1': !haveVSpacing.value,
    'mt-3': haveVSpacing.value,
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})

</script>

<template>
  <div v-if="blockContent" class="grid grid-cols-12 gap-1" :class="containerClasses">
    <div class="col-span-12 p-8 bg-[#dcd6ce] text-[#363330]">
      <HTitle v-if="blockContent.title" class="text-4xl lg:text-5xl mb-4 text-center !text-[#363330]"
              :type="blockContent.titleH">
        {{ blockContent.title }}
      </HTitle>
      <div v-html="blockContent.description" class="mb-4 text-center"></div>
      <iframe class="w-full h-[530px]" :src="shapoIframeUrl"></iframe>
    </div>
  </div>
</template>
